// Button: size and variant modifiers are applied on the same element as .button.
.button {
  --btn-h: var(--vc-control-height);
  --btn-px: 14px;
  --btn-fs: var(--vc-text-md);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: var(--btn-h);
  padding: 0 var(--btn-px);
  border-radius: var(--vc-radius-md);
  font-size: var(--btn-fs);
  font-weight: var(--vc-weight-semibold);
  line-height: 1;
  white-space: nowrap;
  border: 1px solid transparent;
  transition:
    background-color var(--vc-duration) var(--vc-ease),
    border-color var(--vc-duration) var(--vc-ease),
    color var(--vc-duration) var(--vc-ease),
    box-shadow var(--vc-duration) var(--vc-ease),
    transform var(--vc-duration) var(--vc-ease);
  user-select: none;
  text-decoration: none;

  &:hover {
    text-decoration: none;
  }

  &:active:not(:disabled) {
    transform: translateY(1px);
  }

  &:disabled,
  &[aria-disabled='true'] {
    opacity: 0.55;
    cursor: not-allowed;
  }

  // Sizes
  &.sm {
    --btn-h: var(--vc-control-height-sm);
    --btn-px: 10px;
    --btn-fs: var(--vc-text-sm);
    border-radius: var(--vc-radius-sm);
  }

  &.lg {
    --btn-h: var(--vc-control-height-lg);
    --btn-px: 20px;
    --btn-fs: var(--vc-text-base);
  }

  // Variants
  &.primary {
    background: linear-gradient(135deg, #ff5a4e 0%, var(--vc-brand) 70%);
    color: var(--vc-text-on-brand);
    box-shadow: 0 1px 2px rgba(227, 52, 43, 0.3);

    &:hover:not(:disabled) {
      background: linear-gradient(135deg, #ff4f42 0%, var(--vc-brand-hover) 70%);
      box-shadow: 0 8px 20px rgba(227, 52, 43, 0.28);
      transform: translateY(-1px);
    }

    &:active:not(:disabled) {
      background: var(--vc-brand-active);
      box-shadow: 0 1px 2px rgba(227, 52, 43, 0.3);
      transform: translateY(0);
    }
  }

  &.secondary {
    background: var(--vc-surface);
    color: var(--vc-text);
    border-color: var(--vc-border-strong);
    box-shadow: var(--vc-shadow-xs);

    &:hover:not(:disabled) {
      background: var(--vc-surface-muted);
      border-color: var(--vc-text-faint);
    }
  }

  &.ghost {
    background: transparent;
    color: var(--vc-text-secondary);

    &:hover:not(:disabled) {
      background: var(--vc-gray-soft);
      color: var(--vc-text);
    }
  }

  &.soft {
    background: var(--vc-brand-soft);
    color: var(--vc-brand);

    &:hover:not(:disabled) {
      background: var(--vc-brand-soft-border);
    }
  }

  &.danger {
    background: var(--vc-red);
    color: #fff;

    &:hover:not(:disabled) {
      background: var(--vc-brand-hover);
    }
  }

  &.dark {
    background: var(--vc-text);
    color: #fff;

    &:hover:not(:disabled) {
      background: #2a2d38;
    }
  }

  // Layout modifiers
  &.block {
    width: 100%;
  }

  &.iconOnly {
    padding: 0;
    width: var(--btn-h);
  }

  .spinner {
    width: 14px;
    height: 14px;
    border-radius: 50%;
    border: 2px solid currentColor;
    border-right-color: transparent;
    animation: spin 0.7s linear infinite;
  }
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
